/* ==========================================================================
   Featured Collection Tabs — featured-collection.js
   Hover image swap, arrow/dot navigation, AJAX ATC, cart drawer
   ========================================================================== */
(function () {
  'use strict';

  var section = document.querySelector('[id^="fc-section-"]');
  if (!section) return;

  var tabs = section.querySelectorAll('.fc-tab');
  var panels = section.querySelectorAll('.fc-grid-wrap');
  var viewAllBtn = section.querySelector('.fc-view-all');
  var drawer = document.getElementById('fc-drawer');
  var overlay = document.getElementById('fc-drawer-overlay');
  var drawerClose = document.getElementById('fc-drawer-close');
  var drawerBody = document.getElementById('fc-drawer-body');
  var drawerFooter = document.getElementById('fc-drawer-footer');
  var drawerSubtotal = document.getElementById('fc-drawer-subtotal');

  /* ======================================================================
     HELPERS
     ====================================================================== */
  function getSlides(card) {
    return card.querySelectorAll('.fc-card__slide');
  }
  function getDots(card) {
    return card.querySelectorAll('.fc-card__dot');
  }
  function getCurrentIndex(card) {
    var active = card.querySelector('.fc-card__slide--active');
    return active ? parseInt(active.getAttribute('data-index'), 10) : 0;
  }

  function goToSlide(card, targetIndex, applyZoom) {
    var slides = getSlides(card);
    var dots = getDots(card);
    var total = slides.length;
    if (total <= 1 || targetIndex < 0 || targetIndex >= total) return;

    var currentIndex = getCurrentIndex(card);
    if (targetIndex === currentIndex) return;

    slides[currentIndex].classList.remove('fc-card__slide--active', 'fc-card__slide--zoom');
    if (dots.length) dots[currentIndex].classList.remove('fc-card__dot--active');

    slides[targetIndex].classList.add('fc-card__slide--active');
    if (dots.length) dots[targetIndex].classList.add('fc-card__dot--active');

    if (applyZoom && targetIndex !== 0) {
      slides[targetIndex].classList.add('fc-card__slide--zoom');
      function onEnd() {
        slides[targetIndex].classList.remove('fc-card__slide--zoom');
        slides[targetIndex].removeEventListener('animationend', onEnd);
      }
      slides[targetIndex].addEventListener('animationend', onEnd);
    }
  }

  /* ======================================================================
     1. HOVER → SWITCH TO 2ND IMAGE
     ====================================================================== */
  var imageWraps = section.querySelectorAll('.fc-card__image-wrap');
  imageWraps.forEach(function (wrap) {
    var card = wrap.closest('.fc-card');
    if (!card) return;
    var total = parseInt(card.getAttribute('data-total-images') || '0', 10);
    if (total < 2) return;

    var userNavigated = false;

    wrap.addEventListener('mouseenter', function () {
      if (userNavigated) return;
      goToSlide(card, 1, true);
    });

    wrap.addEventListener('mouseleave', function () {
      userNavigated = false;
      goToSlide(card, 0, false);
    });

    wrap.addEventListener('click', function (e) {
      if (e.target.closest('.fc-card__arrow') || e.target.closest('.fc-card__dot')) {
        userNavigated = true;
      }
    });
  });

  /* ======================================================================
     2. ARROW CLICKS
     ====================================================================== */
  section.addEventListener('click', function (e) {
    var arrow = e.target.closest('.fc-card__arrow');
    if (!arrow) return;
    e.preventDefault();
    e.stopPropagation();

    var card = arrow.closest('.fc-card');
    var slides = getSlides(card);
    var total = slides.length;
    if (total <= 1) return;

    var current = getCurrentIndex(card);
    var dir = arrow.getAttribute('data-dir');
    var next;

    if (dir === 'next') {
      next = (current + 1) % total;
    } else {
      next = (current - 1 + total) % total;
    }

    goToSlide(card, next, next !== 0);
  });

  /* ======================================================================
     3. DOT CLICKS
     ====================================================================== */
  section.addEventListener('click', function (e) {
    var dot = e.target.closest('.fc-card__dot');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();

    var card = dot.closest('.fc-card');
    var idx = parseInt(dot.getAttribute('data-dot'), 10);
    goToSlide(card, idx, idx !== 0);
  });

  /* ======================================================================
     4. TAB SWITCHING + VIEW ALL URL UPDATE
     ====================================================================== */
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      if (tab.classList.contains('fc-tab--active')) return;

      tabs.forEach(function (t) { t.classList.remove('fc-tab--active'); });
      tab.classList.add('fc-tab--active');

      var target = tab.getAttribute('data-tab');

      panels.forEach(function (p) {
        p.classList.remove('fc-grid-wrap--active');
        if (p.getAttribute('data-panel') === target) {
          p.classList.add('fc-grid-wrap--active');
          p.querySelectorAll('.fc-card').forEach(function (card) {
            card.style.animation = 'none';
            card.offsetHeight; // reflow
            card.style.animation = '';
          });
        }
      });

      /* Update View All button href based on active tab */
      if (viewAllBtn) {
        if (target === 'bestsellers') {
          viewAllBtn.href = viewAllBtn.getAttribute('data-bs-url') || '/collections/all';
        } else if (target === 'newarrivals') {
          viewAllBtn.href = viewAllBtn.getAttribute('data-na-url') || '/collections/all';
        }
      }
    });
  });

  /* ======================================================================
     5. VARIANT SELECTION
     ====================================================================== */
  section.addEventListener('click', function (e) {
    var varBtn = e.target.closest('.fc-variant-btn');
    if (!varBtn || varBtn.classList.contains('fc-variant-btn--disabled')) return;

    var card = varBtn.closest('.fc-card');
    if (!card) return;

    card.querySelectorAll('.fc-variant-btn').forEach(function (b) {
      b.classList.remove('fc-variant-btn--active');
    });
    varBtn.classList.add('fc-variant-btn--active');

    var priceEl = card.querySelector('.fc-price--current');
    var compareEl = card.querySelector('.fc-price--compare');

    if (priceEl && varBtn.dataset.variantPrice) {
      priceEl.textContent = varBtn.dataset.variantPrice;
    }
    if (compareEl) {
      var cp = varBtn.dataset.variantComparePrice || '';
      if (cp && cp !== varBtn.dataset.variantPrice) {
        compareEl.textContent = cp;
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    var atcBtn = card.querySelector('.fc-atc-btn');
    if (atcBtn) {
      atcBtn.setAttribute('data-variant-id', varBtn.dataset.variantId);
      var available = varBtn.dataset.variantAvailable === 'true';
      atcBtn.disabled = !available;
      var txt = atcBtn.querySelector('.fc-shine-btn__text');
      if (txt) txt.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
    }
  });

  /* ======================================================================
     6. AJAX ADD TO CART
     ====================================================================== */
  section.addEventListener('click', function (e) {
    var atcBtn = e.target.closest('.fc-atc-btn');
    if (!atcBtn || atcBtn.disabled || atcBtn.classList.contains('fc-atc-btn--loading')) return;

    var variantId = atcBtn.getAttribute('data-variant-id');
    if (!variantId) return;

    var textEl = atcBtn.querySelector('.fc-shine-btn__text');
    var original = textEl ? textEl.textContent : 'ADD TO CART';

    atcBtn.classList.add('fc-atc-btn--loading');
    if (textEl) textEl.textContent = 'ADDING';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Failed');
      return res.json();
    })
    .then(function () {
      atcBtn.classList.remove('fc-atc-btn--loading');
      atcBtn.classList.add('fc-atc-btn--added');
      if (textEl) textEl.textContent = 'ADDED ✓';
      setTimeout(function () {
        atcBtn.classList.remove('fc-atc-btn--added');
        if (textEl) textEl.textContent = original;
      }, 1600);
      openDrawer();
      refreshDrawerCart();
      document.dispatchEvent(new CustomEvent('cart:updated'));
    })
    .catch(function () {
      atcBtn.classList.remove('fc-atc-btn--loading');
      if (textEl) textEl.textContent = 'ERROR — RETRY';
      setTimeout(function () { if (textEl) textEl.textContent = original; }, 2000);
    });
  });

  /* ======================================================================
     7. CART DRAWER
     ====================================================================== */
  function openDrawer() {
    if (drawer) drawer.classList.add('fc-drawer--open');
    if (overlay) overlay.classList.add('fc-drawer-overlay--open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (drawer) drawer.classList.remove('fc-drawer--open');
    if (overlay) overlay.classList.remove('fc-drawer-overlay--open');
    document.body.style.overflow = '';
  }

  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('fc-drawer--open')) closeDrawer();
  });

  function refreshDrawerCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderDrawerCart)
      .catch(function () {});
  }

  function renderDrawerCart(cart) {
    if (!drawerBody) return;
    if (!cart.items || !cart.items.length) {
      drawerBody.innerHTML = '<p class="fc-drawer__empty">Your cart is empty</p>';
      if (drawerFooter) drawerFooter.style.display = 'none';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var img = item.featured_image ? item.featured_image.url + '&width=128' : '';
      html += '<div class="fc-drawer__item">';
      if (img) html += '<img class="fc-drawer__item-img" src="' + img + '" alt="' + esc(item.title) + '" loading="lazy">';
      html += '<div class="fc-drawer__item-info">';
      html += '<span class="fc-drawer__item-title">' + esc(item.product_title) + '</span>';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        html += '<span class="fc-drawer__item-variant">' + esc(item.variant_title) + '</span>';
      }
      html += '<span class="fc-drawer__item-price">' + money(item.final_line_price) + ' &times; ' + item.quantity + '</span>';
      html += '</div></div>';
    });

    drawerBody.innerHTML = html;
    if (drawerFooter) drawerFooter.style.display = '';
    if (drawerSubtotal) drawerSubtotal.textContent = money(cart.total_price);
  }

  function money(cents) {
    return 'Rs. ' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  /* ======================================================================
     8. SCROLL PROGRESS (Mobile)
     ====================================================================== */
  section.querySelectorAll('.fc-grid').forEach(function (grid) {
    grid.addEventListener('scroll', function () {
      var wrap = grid.closest('.fc-grid-wrap');
      if (!wrap) return;
      var max = grid.scrollWidth - grid.clientWidth;
      if (max <= 0) return;
      wrap.style.setProperty('--scroll-pct', ((grid.scrollLeft / max) * 70 + 30) + '%');
    });
  });

  /* ======================================================================
     9. SCROLL FADE-IN
     ====================================================================== */
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.style.animationPlayState = 'running';
          obs.unobserve(en.target);
        }
      });
    }, { threshold: 0.12 });

    section.querySelectorAll('.fc-card').forEach(function (card) {
      card.style.animationPlayState = 'paused';
      obs.observe(card);
    });
  }

})();